import { JsonValue } from '@/types/json-type.ts';

export enum UserPreferencesKeys {
  LOCALE = 'locale',
}

export type UserPreferences = {
  [K in UserPreferencesKeys]: JsonValue;
};
